module.exports = __webpack_public_path__ + "assets/images_base/close.svg?v=c909a381";